var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplepodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    className: "cls-1",
    d: "M407,0H105A105.12,105.12,0,0,0,0,105V407A105.12,105.12,0,0,0,105,512H407A105.12,105.12,0,0,0,512,407V105A105.12,105.12,0,0,0,407,0ZM308.56,340.54l-9.27,74.18A30,30,0,0,1,269.52,441h-27a30,30,0,0,1-29.76-26.28l-9.28-74.18A53,53,0,0,1,256,281a45,45,0,1,1,45-45,45.05,45.05,0,0,1-45,45A53,53,0,0,1,308.56,340.54ZM256,161a84.92,84.92,0,0,0-71.49,130.88A83,83,0,0,0,173.43,326a115,115,0,1,1,165.14,0,83.1,83.1,0,0,0-11.07-34.08A84.93,84.93,0,0,0,256,161Zm74.84,243.17,4.62-36.94A145,145,0,0,0,401,246c0-79.95-65.05-145-145-145S111,166.05,111,246a145,145,0,0,0,65.54,121.23l4.62,36.94C122,376.06,81,315.73,81,246c0-96.49,78.51-175,175-175s175,78.51,175,175C431,315.73,390,376.06,330.84,404.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplepodcast);
export default __webpack_public_path__ + "static/media/applepodcast.b328ebe76947da021cfc1269021e7d07.svg";
export { ForwardRef as ReactComponent };